import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {QRCodeSVG} from "qrcode.react";

function ComingSoon() {
    const [t, i18n] = useTranslation();
    const [interfaceUrl, setInterfaceUrl] = useState("coming-soon-interface-desktop.png");

    const isZh = i18n.language === 'zh-HK';

    const appStoreUrl = isZh
        ? 'https://apps.apple.com/hk/app/activikid-%E8%AA%B2%E5%A4%96%E6%B4%BB%E5%8B%95%E9%A0%90%E7%B4%84%E5%B9%B3%E5%8F%B0/id6812852298'
        : 'https://apps.apple.com/hk/app/activikid-kids-activities/id6812852298?l=en-GB';

    const playStoreUrl = isZh
        ? 'https://play.google.com/store/apps/details?id=hk.activikid&hl=zh'
        : 'https://play.google.com/store/apps/details?id=hk.activikid&hl=en';

    // QR points to a device-aware smart link:
    // iPhone/iPad -> App Store, Android -> Google Play (redirected server-side).
    const qrUrl = isZh
        ? 'https://activikid.hk/hk/get-app'
        : 'https://activikid.hk/get-app';

    // Device-aware CTA: iPhone/iPad -> App Store, Android -> Google Play.
    const getStoreHref = () => {
        const ua = window.navigator.userAgent || '';
        const isIOS = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && 'ontouchend' in document);
        const isAndroid = /Android/i.test(ua);
        if (isIOS) return appStoreUrl;
        if (isAndroid) return playStoreUrl;
        return playStoreUrl;
    };

    useEffect(() => {
        const updateSize = () => {
            if (window.innerWidth < 768) {
                setInterfaceUrl("coming-soon-interface-mobile.png");
            } else {
                setInterfaceUrl("coming-soon-interface-desktop.png");
            }
        };
        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    const descriptionAfter = t('coming_soon.description_after');

    return (
        <section className="coming-soon-bg" id="coming-soon">
            <div className="coming-soon-card">
                <div className="coming-soon-illustration">
                    <img
                        src={`/Images/${interfaceUrl}`}
                        className="phone-image img-fluid"
                        alt="ActiviKid App Preview"
                        loading="lazy"
                    />
                </div>
                <div className="coming-soon-content">
                    <img
                        src="/Images/font (white).png"
                        alt="ActiviKid"
                        className="coming-soon-font"
                    />
                    <h2 className="coming-soon-h2">{t('coming_soon.title')}</h2>
                    <p className="coming-soon-p">
                        {t('coming_soon.description_before')}
                        {descriptionAfter ? <br /> : null}
                        {descriptionAfter}
                    </p>

                    {/* Mobile: prominent download button */}
                    <a
                        className="coming-soon-cta"
                        href={getStoreHref()}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t('coming_soon.download_button')}
                    </a>

                    {/* Desktop: QR code to scan */}
                    <div className="coming-soon-qr">
                        <span className="coming-soon-qr-box">
                            <QRCodeSVG value={qrUrl} size={150} level="M" />
                        </span>
                        <span className="coming-soon-qr-caption">{t('coming_soon.qr_caption')}</span>
                    </div>

                    <div className="store-badge-container">
                        <a
                            href={appStoreUrl}
                            className="store-badge-a"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="/Images/new_AppStore.png"
                                className="store-badge-img"
                                alt="Download on the App Store"
                            />
                        </a>
                        <a
                            href={playStoreUrl}
                            className="store-badge-a"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src="/Images/new_GooglePlay.png"
                                className="store-badge-img"
                                alt="Get it on Google Play"
                            />
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ComingSoon;
